import SurveyService from '@/bundles/Survey/services/SurveyService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function surveyServiceFactory() {
  return new SurveyService(http, new ErrorMapper());
}

export const surveyService = surveyServiceFactory();